import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { actions } from "../../../../Redux";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import MultiRangeSlider from "../../../Components/MultiRangeSlider";
import DatePicker from "react-datepicker";
import moment from "moment";
import { useHistory } from "react-router-dom";

const Receivables = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const creditNoteList = useSelector(
    (state) => state?.orderInvoicesReducer?.creditNoteList
  );
  console.log(creditNoteList, "creditNoteList");
  const firstDateOfMonth =
    new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + 1;

  const initialData = {
    from_date: moment(firstDateOfMonth).format("yyyy-MM-DD"),
    to_date: moment(new Date()).format("yyyy-MM-DD"),
    // start_time: "12.00 am",
    // end_time: "12.00 pm",
  };
  const [startDate, setStartDate] = useState(moment(firstDateOfMonth).toDate());
  const [endDate, setEndDate] = useState(new Date());
  const [data, setData] = useState(initialData);

  useEffect(() => {
    // dispatch(actions?.getCreditNoteList(initialData));
    dispatch(actions?.getCreditNoteList());
    return () => {
      dispatch(actions.saveOrderInvoicesValue({ creditNoteList: null }));
    };
  }, []);

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />
        <div className="inner-content">
          <div className="container px-0">
            <div className="row mx-0">
              <div className="container px-0">
                <div class="row mx-0">
                  {/* <div className="field text-right mt-3 pt-1 px-0">
                    <button
                      onClick={() => history.push("/finance/sales")}
                      class="btn green-btn-revert mx-0"
                      id="addCount"
                      type="button"
                    >
                      Back to Sales
                    </button>
                  </div> */}
                  <div class="shadowclass top_filters orderpayy mb-3">
                    <h4 class="event-alert py-0 my-2">Filters </h4>
                    <div className="row mx-0">
                      <div class="col-lg-4 col-md-6 pl0 px-0 px-sm-3">
                        <div class="calander d-flex align-items-center">
                          <div class="datePicker pading_right">
                            {/* // <div class="input-append bootstrap-timepicker date-input datepicker2 date">
                            //   <input
                            //     name="from_date"
                            //     class=" "
                            //     required="required"
                            //     type="text"
                            //     id=""
                            //     value="2022-05-01"
                            //   />
                            //   <span class="add-on">
                            //     <i class="fa fa-calendar"></i>
                            //   </span>
                            // </div> */}
                            <DatePicker
                              selected={startDate}
                              dateFormat="dd/MM/yyyy"
                              onChange={(date) => {
                                setStartDate(date);
                                setData({
                                  ...data,
                                  from_date: moment(date).format("yyyy-MM-DD"),
                                });
                              }}
                            />
                          </div>
                          <div class="datePicker pading_lect">
                            {/* <div class="input-append bootstrap-timepicker date-input datepicker2 date">
                              <input
                                name="to_date"
                                class=" "
                                required="required"
                                type="text"
                                id=""
                                value="2022-05-13"
                              />
                              <span class="add-on">
                                <i class="fa fa-calendar"></i>
                              </span>
                            </div> */}
                            <DatePicker
                              selected={endDate}
                              dateFormat="dd/MM/yyyy"
                              onChange={(date) => {
                                setEndDate(date);
                                setData({
                                  ...data,
                                  to_date: moment(date).format("yyyy-MM-DD"),
                                });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-2 col-md-6 timing-duration pt-4 pt-sm-0 mt-md-3 mt-0 mt-lg-0 px-sm-2">
                        <MultiRangeSlider
                          min={0}
                          max={1440}
                          timeRange
                          format="12"
                          onChange={({ min, max }) => {
                            console.log(`min = ${min}, max = ${max}`);
                            setData({
                              ...data,
                              start_time: min,
                              end_time: max,
                            });
                          }}
                        />
                      </div>
                      <div class="selecters col-lg-5 col-md-10 pl-md-0 row mx-0 justify-content-between pt-0 pt-lg-0">
                        <div class="select-div col px-1 pl-md-0">
                          <div class="input select">
                            <select
                              name="waste_group"
                              class="csutom_select"
                              id="WasteWasteGroup"
                              onChange={(e) =>
                                setData({
                                  ...data,
                                  status_id: e.target.value,
                                })
                              }
                            >
                              <option value="">Customers</option>
                              {creditNoteList?.customers?.map((el) => (
                                <option value={el?.value}>{el?.label}</option>
                              ))}
                            </select>
                          </div>{" "}
                        </div>
                        {/* <div class="select-div col px-1">
                          <div class="input select">
                            <select
                              name="waste_type"
                              class="csutom_select"
                              id="WasteWasteType"
                              onChange={(e) =>
                                setData({
                                  ...data,
                                  type: e.target.value,
                                })
                              }
                            >
                              <option value="">Type</option>
                              {creditNoteList?.type?.map((el) => (
                                <option value={el?.value}>{el?.label}</option>
                              ))}
                            </select>
                          </div>{" "}
                        </div> */}
                        <div class="select-div col px-1">
                          <div class="input select">
                            <select
                              name="supplier"
                              class="csutom_select"
                              id="WasteSupplier"
                              onChange={(e) =>
                                setData({
                                  ...data,
                                  customer_id: e.target.value,
                                })
                              }
                            >
                              <option value="">AR Invoices</option>
                              {creditNoteList?.ar_invoices?.map((el) => (
                                <option value={el?.value}>{el?.label}</option>
                              ))}
                            </select>
                          </div>{" "}
                        </div>
                      </div>
                      <div class="col-lg-1 col px-0 pt-3 pt-lg-0 align-right">
                        <button
                          onClick={() => {
                            dispatch(actions?.getCreditNoteList(data));
                          }}
                          class="btn btn_btnblue"
                          type="submit"
                        >
                          Search
                        </button>
                      </div>
                    </div>
                  </div>{" "}
                </div>
              </div>
            </div>
            <div className="accordion" id="accordionPanelsStayOpenExample">
              <div className="accordion-item">
                <h2
                  className="accordion-header"
                  id="panelsStayOpen-headingNine3"
                >
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseNine3"
                    aria-expanded="true"
                    aria-controls="panelsStayOpen-collapseNine3"
                  >
                    <div className="col d-flex align-items-center justify-content-between">
                      <h4 className="event-alert p-0 mb-0">
                        AR Credit Note List
                      </h4>
                    </div>
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseNine3"
                  className="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-headingNine3"
                >
                  <div className="">
                    <div className="row mx-0">
                      <div className="container px-0">
                        <div className="shadowclass mt-0">
                          <div class="d-flex justify-content-between align-items-center flex-wrap">
                            <div className="col-md-4 col-12">
                              <div className="search-box mt-0">
                                <form onSubmit={(e) => e.preventDefault()}>
                                  <input type="text" placeholder="Search" />
                                  <input type="submit" />
                                </form>
                              </div>
                            </div>
                          </div>
                          <div className="table-responsive general-setting saved_order_ms">
                            <div className="orderList">
                              <table className="checklist-table remove-space ingredTable">
                                <thead>
                                  <tr>
                                    <th>ID</th>
                                    <th>Customer</th>
                                    <th>Status</th>
                                    <th>Invoice ID</th>
                                    <th>Total Value</th>
                                    <th>Redemption Info</th>
                                    <th>Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {creditNoteList?.ar_credit_notes?.map(
                                    (el, idx) => (
                                      <tr>
                                        <td>{el?.rcn_number}</td>
                                        <td>
                                          {el?.customer?.first_name +
                                            " " +
                                            el?.customer?.last_name}
                                        </td>
                                        <td>
                                          <span>{el?.status.status}</span>
                                        </td>
                                        <td>
                                          {el?.ar_invoice.status?.ar_invoiceid}
                                        </td>

                                        <td>{el?.total_price}</td>
                                        <td>{el?.issuance_date}</td>

                                        <td>
                                          <a
                                            onClick={() => {
                                              history.push(
                                                "/order/ar-invoices/new-ar-invoices",
                                                {
                                                  id: el?.id,
                                                  pageType: "edit",
                                                  view: false,
                                                }
                                              );
                                            }}
                                            class="circle_icon"
                                          >
                                            <i class="iconSprites eye-icon"></i>
                                          </a>
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default Receivables;
